<nz-upload
  id="upload"
  class="nz-upload-cropper"
  nzListType="picture-card"
  [nzShowUploadList]="nzShowUploadList"
  [nzBeforeUpload]="nzBeforeUpload"
  (nzChange)="handleNzChange($event)"
  [nzAccept]="nzAccept"
  [ngClass]="{ 'has-preview-image': previewImageUrl }"
  >
  <ng-content></ng-content>
  @if (previewImageUrl) {
    <div class="preview-image">
      <img [src]="previewImageUrl" />
    </div>
  }
</nz-upload>

<nz-modal [(nzVisible)]="isImageCropVisible" (nzOnCancel)="handleCancel()">
  <div *nzModalContent>
    <div class="spacing"></div>
    <image-cropper
      [imageFile]="imageFile"
      [maintainAspectRatio]="maintainAspectRatio"
      [aspectRatio]="_ratio"
      [canvasRotation]="rotate"
      [transform]="transform"
      [cropperMinWidth]="minWidth"
      format="png"
      [autoCrop]="false"
      [resizeToWidth]="resizeToWidth"
    ></image-cropper>
    <div class="slider-container">
      <div nz-row nzJustify="space-between">
        <div nz-col [nzSpan]="1">
          <i nz-icon nzType="zoom-out" nzTheme="outline"></i>
        </div>
        <div nz-col [nzSpan]="21" class="slider">
          <nz-slider (ngModelChange)="onZoomChange()" [nzMin]="0.1" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="zoom"></nz-slider>
        </div>
        <div nz-col [nzSpan]="1">
          <i nz-icon nzType="zoom-in" nzTheme="outline"></i>
        </div>
      </div>

      <div nz-row nzJustify="space-between">
        <div nz-col [nzSpan]="1">
          <i nz-icon nzType="rotate-left" nzTheme="outline"></i>
        </div>
        <div nz-col [nzSpan]="21" class="slider">
          <nz-slider [nzMin]="0" [nzMax]="4" [nzStep]="1" [(ngModel)]="rotate"></nz-slider>
        </div>
        <div nz-col [nzSpan]="1">
          <i nz-icon nzType="rotate-right" nzTheme="outline"></i>
        </div>
      </div>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">{{ 'common.cancel' | translate }}</button>

    <button nz-button nzType="primary" (click)="returnImage()">
      {{ 'common.save' | translate }}
    </button>
  </div>
</nz-modal>
